import { Icon, Message, Popover, Whisper } from 'rsuite'

export default function PopoverMessages({
  datas,
  type = 'info',
  placement = 'bottom',
  trigger = 'click',
  content,
  maxHeight,
  ...props
}) {
  const { style } = props

  const Speaker = ({ content, ...props }) => {
    return (
      <Popover {...props} size="lg">
        <Message
          type={type}
          description={
            <div
              style={{
                whiteSpace: 'pre-line',
                maxHeight: maxHeight || undefined,
                overflowY: 'auto',
                overflowC: 'hidden',
              }}
            >
              {content}
            </div>
          }
          style={{ margin: '-10px -10px' }}
        />
      </Popover>
    )
  }

  return (
    <>
      {content && (
        <Whisper placement={placement} speaker={<Speaker content={content} />} trigger={trigger}>
          <Icon icon="info" style={style || { marginLeft: 10 }} />
        </Whisper>
      )}
    </>
  )
}
